import React, {Fragment} from 'react';
import {HTMLText} from '../HtmlText/HTMLText';
import {createDataTestId} from '../../../utils/dataTestId';

// handle links with %#lnk anchor
const HyperLinkTextByAnchors = ({content = '', onLinkClick}) => {
    if (content === '' || !content.includes('%#lnk')) return <>{content}</>;

    const contentArray = content.split(/%#lnk\d/g);

    //this array contain the links index by number next to #%lnk (#%lnk1, #%lnk2...)
    //the reason we need to extract the number  is because this function happens every paragraph and the link in the current run could start with number bigger then 1
    //if there weher links in the previous paragraph
    const linkAnchorKeyArr = content
        .match(/%#lnk\d/g) // matches all the links anchor and return [%#lnk1, %#lnk1 , %#lnk2, %#lnk2...]
        .filter((lnk, i) => i % 2 !== 0) // remove duplicates return [%#lnk1, %#lnk2...]
        .join('') // convert to string "%#lnk1%#lnk2"
        .split(/%#lnk/) // remove the %#lnk return ["1", "2"]
        .filter(item => item); //remove empty strings

    let anchorIndex = -1;
    return (
        <>
            {contentArray.map((text, i) => {
                //because wie split by the link anchor the link text will allways be in an uneven index number
                if (i % 2 === 0) {
                    return text;
                } else {
                    anchorIndex++;
                    const funcIndex = parseInt(linkAnchorKeyArr[anchorIndex]) - 1;
                    return (
                        <a //eslint-disable-next-line
                            href="#"
                            onClick={
                                Array.isArray(onLinkClick) ? onLinkClick[funcIndex] : onLinkClick
                            }
                            key={i}
                        >
                            {text}
                        </a>
                    );
                }
            })}
        </>
    );
};

// break line in text
export const TextBreakLine = props => {
    const {content, onLinkClick, withLinks = false} = props;

    return content
        ? content.split('\n').map((par, i) => (
              <Fragment key={i}>
                  {i > 0 && <br />}
                  {withLinks ? (
                      <HyperLinkTextByAnchors content={par} onLinkClick={onLinkClick} />
                  ) : (
                      par
                  )}
              </Fragment>
          ))
        : '';
};

//handle links from linkData array
export const HyperlinkMarkup = ({content, linkData, handleOnClickLink, componentClasses}) => {
    let lastLen = 0;

    return linkData.map((link, i) => {
        const text = content.substring(lastLen, link.from);
        lastLen = Number(link.from) + Number(link.len);

        return (
            <span key={i} className={componentClasses}>
                <span>
                    <TextBreakLine content={text} />
                </span>
                <a
                    href="#"
                    onClick={() => {
                        handleOnClickLink(link.linkData);
                    }}
                >
                    {link.title}
                </a>
                {i === linkData.length - 1 && (
                    <span>
                        <TextBreakLine content={content.substring(lastLen, content.length)} />
                    </span>
                )}
            </span>
        );
    });
};

const isHTML = text => {
    const html = new DOMParser().parseFromString(text, 'text/html');
    const paragraph = html.body.querySelectorAll('p');
    return paragraph.length > 0;
};

const isPriorityStoreLink = text => {
    return text?.includes('[priorityshop]');
};

//prepare text - handle all kind of links and breaking
type HyperLinkTextProps = {
    text: any;
    linkData: any;
    onLinkClick: (linkData: any) => void;
    componentClasses?: string;
};

export const HyperlinkText = ({
    text,
    linkData,
    onLinkClick,
    componentClasses
}: HyperLinkTextProps) => {
    if (isHTML(text)) {
        return (
            <HTMLText
                componentClasses={componentClasses}
                content={text}
                linkData={linkData}
                onLinkClick={onLinkClick}
            />
        );
    }

    if (isPriorityStoreLink(text)) {
        return (
            <HTMLText
                componentClasses={componentClasses}
                content={text}
                linkData={linkData}
                isPriorityShop={true}
                onLinkClick={onLinkClick}
            />
        );
    }
    const markup = linkData && linkData.length > 0 && text && (
        <HyperlinkMarkup
            componentClasses={componentClasses}
            content={text}
            linkData={linkData}
            handleOnClickLink={onLinkClick}
        />
    );

    return markup ? (
        <div style={{lineHeight: '1.5'}} {...createDataTestId('hyperlink-text-markup', false)}>
            {markup}
        </div>
    ) : (
        <div {...createDataTestId('hyperlink-text-no-markup')}>
            <TextBreakLine withLinks={true} onLinkClick={onLinkClick} content={text} />
        </div>
    );
};
